// @flow
export { default as blog } from 'client/reducers/blog';
export { default as cache } from 'universal/reducers/cache';
export { default as contentfulData } from 'client/reducers/contentful';
export { default as expenses } from 'client/reducers/tax/expenses';
export { default as professions } from 'client/reducers/tax/professions';
export { default as siteConfigs } from 'client/reducers/siteConfigs';
export { default as sms } from 'client/reducers/sms';
export { default as taxBenefits } from './taxBenefits';
export { default as taxConfig } from './taxConfig';
export { default as translations } from 'client/reducers/translations';
export { default as user } from 'client/reducers/user';
export const brand = (state: string = 'stride') => state;
